import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
// import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// import { Provider } from 'react-redux';
// import { createStore, applyMiddleware } from 'redux';
// import rootReducer from "./reducer";
// import createSagaMiddleware from 'redux-saga';
// import RootSaga from "./root.saga";
// import { AppContainer } from 'react-hot-loader';
import Routes from "./routes.js";
// import { render } from 'react-dom';
import "./utils/common.js";
import "./styles/index.scss";
import "./utils/common.less";
import 'react-toastify/dist/ReactToastify.css';
import store from './store.js';

// const sagaMiddleware = createSagaMiddleware();

// export const store = createStore(
// 	rootReducer,
// 	applyMiddleware(sagaMiddleware)
// );

// sagaMiddleware.run(function* () {
// 	yield RootSaga();
// });

// const root = ReactDOM.createRoot(document.getElementById('root'));

// root.render(
//   // <Provider store={store} >
//     // <BrowserRouter>
//       <Routes store={store}/>
//     // </BrowserRouter>
//   // </Provider>
// );




ReactDOM.render(
  <Fragment>
    <Routes store={store} />
  </Fragment>,
  document.getElementById('root')
);




// module.hot.accept();


